const FIELD_LABELS = {
  name: "Holiday name",
  date: "Date",
  description: "Description",
  type: "Type",
};

function formatFieldName(field) {
  return FIELD_LABELS[field] || field;
}

function formatFieldValue(field, value) {
  if (value === null || value === undefined || value === "") return "—";
  if (field === "type") {
    const v = String(value).toLowerCase();
    return v === "floating" ? "Floating Holiday" : "Public Holiday";
  }
  if (field === "date") {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString();
  }
  return String(value);
}

export default function HolidayActivityLogDetails({ entry }) {
  if (!entry || entry.entityType !== "holiday" || !entry.metadata) return null;
  const changes = Array.isArray(entry.metadata?.changes) ? entry.metadata.changes : [];
  const snapshot = entry.metadata?.snapshot;

  if (!changes.length && !snapshot) return null;

  if ((entry.action === "holiday_created" || entry.action === "holiday_deleted") && snapshot) {
    const fields = ["name", "date", "description", "type"];
    return (
      <div className="mt-2 space-y-1">
        {fields.map((field) => (
          <div key={`${entry.id}-${field}`} className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1">
            <span className="font-semibold">{formatFieldName(field)}:</span>{" "}
            <span className="text-gray-800">{formatFieldValue(field, snapshot[field])}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mt-2 space-y-1">
      {changes.map((change, idx) => (
        <div
          key={`${entry.id}-${change.field}-${idx}`}
          className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1"
        >
          <span className="font-semibold">{formatFieldName(change.field)}:</span>{" "}
          <span className="text-gray-500">
            {formatFieldValue(change.field, change.previousValue)}
          </span>{" "}
          <span className="text-gray-400">→</span>{" "}
          <span className="text-gray-800">
            {formatFieldValue(change.field, change.newValue)}
          </span>
        </div>
      ))}
    </div>
  );
}
